import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import {
 Button,
 Container,
 FormControl,
 FormControlLabel,
 FormLabel,
 Radio,
 RadioGroup,
 Rating,
 TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { msalConfig } from "../../authConfig";
import { baseURL } from "../Constant";
import { handleIdValidation } from "../Redux/Approver";
import "./FeedbackForm.css";

const ColorButton = styled(Button)(({ theme }) => ({
 color: theme.palette.getContrastText("#7500C0"),
 backgroundColor: "#7500C0",
 "&:hover": {
  backgroundColor: "#7500C0",
  color: "#fff",
 },
}));

const CustomRating = styled(Rating)({
 "& .MuiRating-label": {
  fontSize: "14.5rem", // Adjust the font size here
 },
});

const FeedbackForm = ({
 handleCloseModal,
 uniqueID,
 isFeedbackSuccess,
 setIsFeedbackSuccess,
 campaignId,
}) => {
 const [expectationsMet, setExpectationsMet] = useState("");
 const [rating, setRating] = useState(0);
 const [overallRating, setOverallRating] = useState(0);
 const [comments, setComments] = useState("");
 const [sendReceipt, setSendReceipt] = useState(false);
 const [response, setResponse] = useState(null);
 const [error, setError] = useState("");
 const [userID, setUserID] = useState(null);
 const [submitted, setSubmitted] = useState(false);
 const msalInstance = new PublicClientApplication(msalConfig);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const dispatch = useDispatch();
 const handleSubmit = async (event) => {
  event.preventDefault();
  setSubmitted(true);
  if (userID == null || userID == "false" || userID == undefined || userID == "") {
   dispatch(handleIdValidation(true));
  } else {
   dispatch(handleIdValidation(false));

   if (comments.trim() === "") {
    return; // Do not proceed if comments are empty
   }

   try {
    const res = await axios.post(`${baseURL}/sendFeedback`, {
     enterpriseID: userID,
     expectationsMet,
     overallRating,
     comments,
     uniqueID,
     campaignId: campaignId,
    });
    setResponse(res.data);
    setError("");
    handleCloseModal();
    setIsFeedbackSuccess(true);
   } catch (e) {
    //Handling error
    setResponse(null);
    setError("There was an error with the request.");
    handleCloseModal();
    setIsFeedbackSuccess(false);
   }
  }
 };

 useEffect(() => {
  if (activeAccount) {
   setUserID(activeAccount.idTokenClaims.enterpriseID);
  }
 }, [activeAccount]);

 return (
  <div className="feedback-form-container">
   <Container maxWidth="sm" sx={{ marginTop: "10px", paddingLeft: "12px" }}>
    <form onSubmit={handleSubmit}>
     <FormControl component="fieldset">
      {" "}
      <p style={{ fontSize: "16px" }}>
       1. Is the template generated as per the expectations?
      </p>
      <RadioGroup
       value={expectationsMet}
       onChange={(e) => setExpectationsMet(e.target.value)}
       sx={{
        padding: "4px",
        flexDirection: "row",
        "& .MuiFormControlLabel-root": {
         fontSize: "0.75rem", // Adjust the font size of the labels
        },
        "& .MuiRadio-root": {
         fontSize: "1rem", // Adjust the size of the radio buttons
        },
       }}
      >
       <FormControlLabel
        value="yes"
        control={
         <Radio
          sx={{
           "&.Mui-checked": {
            color: "#8a2be2", // Change the selected color here
           },
           "& .MuiRadio-root": { color: "black" },
          }}
         />
        }
        label="Yes"
       />
       <FormControlLabel
        value="no"
        control={
         <Radio
          sx={{
           "&.Mui-checked": {
            color: "#8a2be2", // Change the selected color here
           },
           "& .MuiRadio-root": { color: "black" },
          }}
         />
        }
        label="No"
       />
      </RadioGroup>
     </FormControl>

     {/* <FormControl component="fieldset" sx={{ marginTop: "10px" }}>
      <FormLabel
       component="legend"
       sx={{
        marginBottom: "5px",
        marginTop: "10px",
        color: "#000", // Change the label color here
        "& .MuiFormControlLabel-label": {
         color: "#000", // Change the label color specifically
        },
       }}
      >
       {" "}
       2. Please rate your experience on the CommsBuilder Tool
      </FormLabel>
      <Rating
       name="overall-experience"
       value={rating}
       onChange={(e, newValue) => setRating(newValue)}
       precision={1}
       icon={<StarIcon style={{ width: "26px", height: "26px" }}></StarIcon>}
       emptyIcon={
        <StarOutlineIcon style={{ width: "26px", height: "26px" }}></StarOutlineIcon>
       }
      />
     </FormControl> */}

     <FormControl component="fieldset" sx={{ marginTop: 3 }}>
      <FormLabel
       component="legend"
       sx={{
        marginBottom: "5px",
        color: "#000", // Change the label color here
        "& .MuiFormControlLabel-label": {
         color: "#000", // Change the label color specifically
        },
       }}
      >
       {" "}
       2. Please rate your overall experience
      </FormLabel>
      <Rating
       name="overall-experience"
       value={overallRating}
       onChange={(e, newValue) => setOverallRating(newValue)}
       precision={1}
       className="custom-rating"
       icon={<StarIcon style={{ width: "26px", height: "26px" }}></StarIcon>}
       emptyIcon={
        <StarOutlineIcon style={{ width: "26px", height: "26px" }}></StarOutlineIcon>
       }
      />
     </FormControl>

     <FormLabel
      component="legend"
      sx={{
       // marginBottom: "5px",
       marginTop: 3,
       color: "#000", // Change the label color here
       "& .MuiFormControlLabel-label": {
        color: "#000", // Change the label color specifically
       },
      }}
     >
      {" "}
      3. We value your opinion! Please share your views with us.
     </FormLabel>
     <TextField
      placeholder="Comments"
      variant="outlined"
      multiline
      rows={2}
      fullWidth
      value={comments}
      onChange={(e) => setComments(e.target.value)}
      error={submitted && comments.trim() === ""} // Set error state if comments are empty
      helperText={submitted && comments.trim() === "" ? "Comments are required." : ""}
      sx={{
       width: "96%",
       marginLeft: "15px",
       marginTop: 1,
       "& .MuiOutlinedInput-root": {
        "& fieldset": {
         borderColor: "gray", // Border color for the TextField
        },
        "&:hover fieldset": {
         borderColor: "gray", // Border color when hovering over the TextField
        },
        "&.Mui-focused fieldset": {
         borderColor: "gray", // Border color when the TextField is focused
        },
       },
       "& .MuiInputLabel-root": {
        color: "#000", // Color of the label
       },
       "& .MuiInputLabel-root.Mui-focused": {
        color: "#000", // Color of the label when focused
       },
      }}
     />

     {/* <FormControlLabel
          control={
            <Checkbox
              checked={sendReceipt}
              onChange={(e) => setSendReceipt(e.target.checked)}
            />
          }
          label="Send me an email receipt of my responses"
          sx={{ marginTop: 2 }}
        /> */}
     <div className="feedback-btn-container">
      {/* <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{
                marginTop: 3,
                marginLeft: "15px",
                backgroundColor: "#8a2be2", // Custom color
                "&:hover": {
                  backgroundColor: "#8a2be2", // Custom hover color
                },
              }}
            > */}
      <ColorButton
       variant="contained"
       className="cancel-button"
       size="small"
       // onClick={handleOpenAdd}
       type="submit"
       sx={{
        "background-color": "white",
        color: "black",
        border: "2px solid blueviolet",
        "border-radius": "18px",
        "text-transform": "capitalize",
        padding: "5px 29px",
        "font-weight": "600",
        "font-size": "14px",
        marginRight: "10px",
       }}
      >
       Submit
      </ColorButton>
      {/* </Button> */}
      {/* <Button
              variant="contained"
              color="primary"
              onClick={handleCloseModal}
              sx={{
                marginTop: 3,
                marginLeft: "15px",
                backgroundColor: "#8a2be2", // Custom color
                "&:hover": {
                  backgroundColor: "#8a2be2", // Custom hover color
                },
              }}
            > */}
      <ColorButton
       variant="contained"
       className="cancel-button"
       size="small"
       onClick={handleCloseModal}
       // type="submit"
       sx={{
        "background-color": "white",
        color: "black",
        border: "2px solid blueviolet",
        "border-radius": "18px",
        "text-transform": "capitalize",
        padding: "5px 29px",
        "font-weight": "600",
        "font-size": "14px",
       }}
      >
       Cancel
      </ColorButton>
      {/* </Button> */}
      {/* <span
              className="close_btn_model"
              onClick={handleCloseModal}
              tabIndex={0}
              
            >
              Close
            </span> */}
     </div>
    </form>
   </Container>
  </div>
 );
};

export default FeedbackForm;
